module.exports = __webpack_public_path__ + "static/carbon-datepicker-basic-78995044b077f229dd6f763d130f7e9f.png";